<div [dlNodeVolger]="node" [cy]="cy" ankertype="rechtsonder" [offset]="{x: 5, y: 5}" [volgFormaat]="false" [schaalMetZoom]="false" [zichtbaarAls]="modelcanvas.nodeOverlaysZichtbaar" class="dl-nodemenu__holder" (pointerover)="opItemHover($event)" (pointerleave)="opMenuVerlaten()">
    <ul class="dl-nodemenu">
        @if (!condtag) {
            <li class="dl-nodemenu__item" data-uitleg="q_exo_decr" (click)="uitvoerChangeAction({type: 'q_exo_decr'})" title="{{ 'ADD_EXO_DECR' | translate }}">
                <a class="q_exo_menuitem q_exo_decr"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="q_exo_steady" (click)="uitvoerChangeAction({type: 'q_exo_steady'})" title="{{ 'ADD_EXO_STEADY' | translate }}">
                <a class="q_exo_menuitem q_exo_steady"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="q_exo_incr" (click)="uitvoerChangeAction({type: 'q_exo_incr'})" title="{{ 'ADD_EXO_INCR' | translate }}">
                <a class="q_exo_menuitem q_exo_incr"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="q_exo_sin" (click)="uitvoerChangeAction({type: 'q_exo_sin'})" title="{{ 'ADD_EXO_SIN' | translate }}">
                <a class="q_exo_menuitem q_exo_sin"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="q_exo_para_pos" (click)="uitvoerChangeAction({type: 'q_exo_para_pos'})" title="{{ 'ADD_EXO_PARA_POS' | translate }}">
                <a class="q_exo_menuitem q_exo_para_pos"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="q_exo_para_neg" (click)="uitvoerChangeAction({type: 'q_exo_para_neg'})" title="{{ 'ADD_EXO_PARA_NEG' | translate }}">
                <a class="q_exo_menuitem q_exo_para_neg"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="q_exo_random" (click)="uitvoerChangeAction({type: 'q_exo_random'})" title="{{ 'ADD_EXO_RAND' | translate }}">
                <a class="q_exo_menuitem q_exo_random"></a>
            </li>
        }
        <li class="dl-nodemenu__separator dl-nodemenu__item"></li>
        <li class="dl-nodemenu__item" (click)="uitvoerEditBallon()" title="{{ 'BALLON.BTN_TITLE' | translate }}">
            <a class="fa_item"><span class="fa-regular fa-comment"></span></a>
        </li>
    </ul>
</div>
